/**
 * VIP / 群 VIP / 官方客服徽标（21g）。档位与文案单点在 `~/chat/vipBadge`。
 *
 * 用在昵称后面：会话列表行、消息气泡昵称、通讯录行、资料页。旧版
 * `VipBadge` / `VipBadge.group` 的位置与语义照搬，视觉改纯 CSS（不引 PNG）。
 * view=null 时不渲染任何节点（调用方不用自己判）。
 */
import type { PremiumBadgeView, RoleBadgeView, VipBadgeView } from '~/chat/vipBadge';
import styles from './vipBadge.module.scss';

export function VipBadge({ view }: { view: VipBadgeView | null }) {
  if (view === null) return null;
  // 有素材走原图（21g-5）；没有素材的档位（后端定义之外）回落纯 CSS 文字徽标，
  // 与旧版 bounds==null 时画文字胶囊同口径
  if (view.icon !== null) {
    return (
      <img
        className={styles.icon}
        src={view.icon}
        alt={view.label}
        title={view.label}
        data-testid="vip-badge"
        data-tone={view.tone}
        loading="lazy"
        decoding="async"
      />
    );
  }
  return (
    <span
      className={`${styles.badge} ${styles[view.tone]}`}
      data-testid="vip-badge"
      data-tone={view.tone}
      title={view.label}
      aria-label={view.label}
    >
      {view.short}
    </span>
  );
}

/**
 * 群内身份徽标（21g-2）：群主 / 管理员。旧版 `SenderRoleBadge` 同位置同语义，
 * 浅底深字与 VIP 的实底区分开。view=null 不渲染。
 */
export function RoleBadge({ view }: { view: RoleBadgeView | null }) {
  if (view === null) return null;
  return (
    <span
      className={`${styles.role} ${styles[view.tone]}`}
      data-testid="role-badge"
      data-tone={view.tone}
    >
      {view.label}
    </span>
  );
}

/**
 * 靓号徽标（21g-4；21g-5 改用旧版原始素材）。号码进 title/alt。view=null 不渲染。
 */
export function PremiumBadge({ view }: { view: PremiumBadgeView | null }) {
  if (view === null) return null;
  return (
    <img
      className={styles.icon}
      src={view.icon}
      alt={view.label}
      title={view.label}
      data-testid="premium-badge"
      data-no={view.premiumNo}
      loading="lazy"
      decoding="async"
    />
  );
}
